<div class="flex min-w-0 flex-auto flex-col sm:absolute sm:inset-0 sm:overflow-hidden">
    <!-- Main -->
    <div class="bg-card flex w-full flex-auto overflow-hidden" fuseScrollbar>
        <div class="w-full pl-5">
            <!-- Spacer -->
            <div class="h-10"></div>

            <div markdown class="prose mb-10 flex min-w-full flex-col text-sm" [src]="'CHANGELOG.md'"></div>

            <!-- Spacer -->
            <div class="h-20"></div>
        </div>
    </div>
</div>
